export default __webpack_public_path__ + "static/media/ScoutAndCellar.d515c8c6.png";